import ContactForm from '../components/forms/ContactForm';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function ContactPage() {
  const { t } = useTranslation();
  return (
    <main>
      <Helmet>
        <title>{t('seo.contact_title')}</title>
      </Helmet>
      <h1>{t('nav.contact')}</h1>
      <div style={{ display: 'grid', gridTemplateColumns:'1fr 1fr', gap: 24 }}>
        <ContactForm />
        <iframe 
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.240673811163!2d20.46123!3d44.812544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a7aa0f5f2b2bd%3A0x2d2b71d9b5a3b48b!2sBelgrade!5e0!3m2!1sen!2srs!4v1616161616161"
          width="100%" height="300" style={{ border: 0 }} allowFullScreen="" loading="lazy"
        />
      </div>
    </main>
  );
}
